import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import CategoriesList from "./CategoriesList";
import CategoryCreate from "./CategoryCreate";
import CategoryEdit from "./CategoryEdit";
import CategoryGroups from "./CategoryGroups";

function Categories() {
  return (
    <Routes>
      <Route index element={<CategoriesList />} />
      <Route path="create" element={<CategoryCreate />} />
      <Route path="edit/:categoryId" element={<CategoryEdit />} />
      <Route path="groups/*" element={<CategoryGroups />} />
      <Route path="*" element={<Navigate to="/dashboard/categories" replace />} />
    </Routes>
  );
}

export default Categories;